import { ReactNode } from "react";
import { ActionsContainer, StickyWrapper } from "./styles";

interface SquadActionBarProps {
  children: ReactNode;
}

const SquadActionBar = ({ children }: SquadActionBarProps) => {
  return (
    <StickyWrapper>
      <ActionsContainer>{children}</ActionsContainer>
    </StickyWrapper>
  );
};

export default SquadActionBar;
